module.exports = __webpack_public_path__ + "static/img/ppt-3.51b8630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt-3.jpg
// module id = Ie2v
// module chunks = 1